import eicr from "@/data/insights/eicr-checklist-for-industrial-premises";
import ppm from "@/data/insights/ppm-vs-reactive-maintenance-true-cost";
import plc from "@/data/insights/how-often-should-you-service-a-plc";
import panel from "@/data/insights/choosing-a-control-panel-builder";

// Ordered newest-first for the index page.
export const INSIGHTS = [eicr, ppm, plc, panel];

export const INSIGHTS_BY_SLUG = Object.fromEntries(
  INSIGHTS.map((a) => [a.slug, a])
);

// Given a slug, return up to `n` other articles preferring same category first.
export const getRelatedArticles = (currentSlug, n = 3) => {
  const current = INSIGHTS_BY_SLUG[currentSlug];
  if (!current) return INSIGHTS.slice(0, n);
  const sameCat = INSIGHTS.filter(
    (a) => a.slug !== currentSlug && a.category === current.category
  );
  const others = INSIGHTS.filter(
    (a) => a.slug !== currentSlug && a.category !== current.category
  );
  return [...sameCat, ...others].slice(0, n);
};

// Shallow "card" view for grids — strips the heavy body content.
export const asCard = (a) => ({
  slug: a.slug,
  title: a.title,
  dek: a.dek,
  category: a.category,
  readTime: a.readTime,
  publishedAt: a.publishedAt,
  image: a.image,
});
